import { timelineEvents } from "@/mocks/home";
import Reveal from "./Reveal";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <Reveal className="mb-10 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.35em] text-primary-600">TIMELINE</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              时间线还原 · 逐层对齐
            </h2>
          </div>
          <p className="max-w-md font-body text-sm leading-relaxed text-foreground-600">
            把公开动作与截图时间戳放在同一根轴上，缺口与矛盾点会自己浮现出来。
          </p>
        </Reveal>

        <div className="relative">
          <span className="absolute left-[13px] top-2 hidden h-[calc(100%-1rem)] w-px bg-background-300 md:block" />
          <div className="flex flex-col gap-5">
            {timelineEvents.map((event, index) => (
              <Reveal key={event.time} delay={index * 70}>
                <div className="flex flex-col gap-4 md:flex-row md:items-start md:gap-6">
                  <div className="flex items-center gap-4 md:w-[150px] md:shrink-0">
                    <span className="relative z-10 flex h-7 w-7 items-center justify-center rounded-full border-2 border-accent-500 bg-background-50">
                      <span className="h-2.5 w-2.5 rounded-full bg-accent-500" />
                    </span>
                    <span className="font-heading text-lg font-bold text-foreground-950">{event.time}</span>
                  </div>

                  <div className="flex flex-1 flex-col gap-4 rounded-lg border border-background-200 bg-background-100 p-4 md:flex-row md:items-center md:p-5">
                    <div className="flex-1">
                      <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                        {event.title}
                      </h3>
                      <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">{event.desc}</p>
                    </div>
                    {event.image ? (
                      <div className="h-[120px] w-full shrink-0 overflow-hidden rounded-md bg-background-200 md:h-[110px] md:w-[150px]">
                        <img
                          src={event.image}
                          alt={`黑料图文时间线：${event.title}`}
                          title="黑料图文时间线还原"
                          className="h-full w-full object-cover object-top"
                        />
                      </div>
                    ) : (
                      <div className="flex h-[70px] w-full shrink-0 items-center justify-center gap-2 rounded-md border border-dashed border-background-400 bg-background-50 md:h-[110px] md:w-[150px]">
                        <i className="ri-file-list-3-line text-xl text-foreground-400" />
                        <span className="font-label text-xs text-foreground-500">节点记录</span>
                      </div>
                    )}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}